function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import react, { useEffect, useState } from "react";
import moment from "moment";
import useAxios from "../../../../Hooks/use-axios";
import useSearchInput from "../../../../Hooks/useSearchInput";
import { toast } from "react-toastify";
import { isMahindra } from "../../../../utils/isClient";
import { logoutHandler, removeLocalTokens, removeSessionTokens } from "../../../../utils/tokens";
var useData = function useData(isRewards, isCustom) {
  var _redux$auth, _ref2, _ref3, _dealsState$isRefresh, _redux$webView;
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    config = _ref.config,
    winnreAuth = _ref.winnreAuth,
    cmsClient = _ref.cmsClient;
  var isPoints = arguments.length > 3 ? arguments[3] : undefined;
  var location = (router === null || router === void 0 ? void 0 : router.location) || {
    search: ""
  };
  var history = router === null || router === void 0 ? void 0 : router.history;
  var queryParams = new URLSearchParams(location.search);
  var tagID = queryParams.get("tagID");
  var categoryID = queryParams.get("categoryID");
  var brandID = queryParams.get("brandID");
  var brandName = queryParams.get("brandName");
  var tagName = queryParams.get("tagName");
  var categoryName = queryParams.get("categoryName");
  var search = queryParams.get("search");
  var authActions = (redux === null || redux === void 0 ? void 0 : redux.authActions) || {};
  var callback = function callback(searchValue) {
    var _window;
    (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("OfferSearched", {
      searchQuery: "".concat(searchValue)
    });
    getOffers();
  };
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    offers = _useState2[0],
    setOffers = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    categories = _useState4[0],
    setCategories = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    brands = _useState6[0],
    setBrands = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    tags = _useState8[0],
    setTags = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    topOffers = _useState0[0],
    setTopOffers = _useState0[1];

  // const [selectedTags, setSelectedTags] = useState(
  //     tagID ? [{ value: Number(tagID), label: tagName }] : []
  // );
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedTags = _useState10[0],
    setSelectedTags = _useState10[1];
  var ENV = window.reloy_env.ENV || process.env.REACT_APP_ENV;
  console.log("ENV", ENV);
  useEffect(function () {
    if (tagID) {
      var matchedTag = tags.find(function (tag) {
        return tag.id === Number(tagID);
      });
      if (tagName || matchedTag) {
        setSelectedTags([{
          value: Number(tagID),
          label: tagName || (matchedTag === null || matchedTag === void 0 ? void 0 : matchedTag.name)
        }]);
      }
    }
  }, [tagID, tagName, tags]); // Dependency array ensures this runs when tags or tagID changes.

  useEffect(function () {
    if (isCustom) {
      var matchedTag = tags.find(function (tag) {
        return tag.id === Number(ENV == "PRODUCTION" ? 116 : ENV == "UAT" ? 77 : 137);
      });
      // if (matchedTag) {
      setSelectedTags([{
        value: Number(ENV == "PRODUCTION" ? 116 : ENV == "UAT" ? 77 : 137),
        label: (matchedTag === null || matchedTag === void 0 ? void 0 : matchedTag.name) || ""
      }]);
    }
    // }
  }, [isCustom, tags]); // Dependency array ensures this runs when tags or tagID changes.
  console.log("tags", selectedTags);
  var _useState11 = useState(brandID ? [{
      value: Number(brandID),
      label: brandName
    }] : []),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedBrands = _useState12[0],
    setSelectedBrands = _useState12[1];
  var _useState13 = useState(categoryID ? [{
      value: Number(categoryID),
      label: categoryName
    }] : []),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedCategories = _useState14[0],
    setSelectedCategories = _useState14[1];
  var _useSearchInput = useSearchInput(search ? search : "", callback),
    _useSearchInput2 = _slicedToArray(_useSearchInput, 2),
    searchInput = _useSearchInput2[0],
    handleChange = _useSearchInput2[1];
  var _useState15 = useState(8),
    _useState16 = _slicedToArray(_useState15, 2),
    loadMoreOffers = _useState16[0],
    setLoadMoreOffers = _useState16[1];
  var _useState17 = useState(1),
    _useState18 = _slicedToArray(_useState17, 2),
    totalPages = _useState18[0],
    setTotalPages = _useState18[1];
  var _useState19 = useState(1),
    _useState20 = _slicedToArray(_useState19, 2),
    currentPage = _useState20[0],
    setCurrentPage = _useState20[1];
  var _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    unauthorizedUserMessage = _useState22[0],
    setUnauthorizedUserMessage = _useState22[1];
  var isAuthenticated = redux === null || redux === void 0 || (_redux$auth = redux.auth) === null || _redux$auth === void 0 ? void 0 : _redux$auth.isAuthenticated;
  var dealsState = (redux === null || redux === void 0 ? void 0 : redux.deals) || (redux === null || redux === void 0 ? void 0 : redux.deal) || {};
  var isRewardRefreshing = (_ref2 = (_ref3 = (_dealsState$isRefresh = dealsState === null || dealsState === void 0 ? void 0 : dealsState.isRefreshRewards) !== null && _dealsState$isRefresh !== void 0 ? _dealsState$isRefresh : dealsState === null || dealsState === void 0 ? void 0 : dealsState.isRewardRefreshing) !== null && _ref3 !== void 0 ? _ref3 : redux === null || redux === void 0 ? void 0 : redux.isRefreshRewards) !== null && _ref2 !== void 0 ? _ref2 : redux === null || redux === void 0 ? void 0 : redux.isRewardRefreshing;
  var isInternalWebview = redux === null || redux === void 0 || (_redux$webView = redux.webView) === null || _redux$webView === void 0 ? void 0 : _redux$webView.internalWebview;
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var clearFilters = function clearFilters() {
    setSelectedTags([]);
    setSelectedBrands([]);
    setSelectedCategories([]);
  };
  useEffect(function () {
    if (selectedTags.length > 0 || selectedCategories.length > 0 || selectedBrands.length > 0) {
      var _window2;
      (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webengage) === null || _window2 === void 0 || _window2.track("SearchFilterApplied", {
        selectedTags: selectedTags.map(function (tag) {
          return tag.label;
        }),
        selectedCategories: selectedCategories.map(function (category) {
          return category.label;
        }),
        selectedBrands: selectedBrands.map(function (brand) {
          return brand.label;
        })
      });
    }
  }, [selectedTags, selectedCategories, selectedBrands]);
  var logout = function logout() {
    setOffers([]);
    setTotalPages(0);
    if (isMahindra(config)) {
      removeSessionTokens();
    } else {
      removeLocalTokens();
    }
    logoutHandler(dispatch, winnreAuth, authActions);
  };
  var _useAxios = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    loadingOffers = _useAxios.isLoading,
    offersHasError = _useAxios.error,
    fetchOffers = _useAxios.sendRequest;
  var _useAxios2 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    fetchTags = _useAxios2.sendRequest;
  var _useAxios3 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    fetchBrands = _useAxios3.sendRequest;
  var _useAxios4 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    fetchCategories = _useAxios4.sendRequest;
  var _useAxios5 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    loadingSimilarDeals = _useAxios5.isLoading,
    fetchSimilarDeals = _useAxios5.sendRequest;
  var date = moment().format();
  var tagList = selectedTags.map(function (tag) {
    return tag.value;
  });
  var categoryList = selectedCategories.map(function (category) {
    return category.value;
  });
  var vendorList = selectedBrands.map(function (brand) {
    return brand.value;
  });
  console.log("tagList", tagList);
  console.log("categoryList", categoryList);
  console.log("vendorList", vendorList);
  var getOffersOfTheMonth = function getOffersOfTheMonth() {
    winnreAuth === null || winnreAuth === void 0 || winnreAuth({
      method: "GET",
      url: "/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&categoryList=1,2,3,5&pageSize=10&tagList=52".concat(isRewards === true ? "&rewardsPage=true" : "")
    }).then(function (data) {
      setTopOffers((data === null || data === void 0 ? void 0 : data.content) || []);
    });
  };
  var getOffers = function getOffers() {
    var oldCartData = isPoints ? localStorage.getItem("cartData_reloyrewardpoints") : localStorage.getItem("cartData");
    var cartData = oldCartData ? JSON.parse(oldCartData) : {
      totalPoints: 0
    };
    var url;
    if (isAuthenticated) {
      url = "/winnre/user/deals/filter-v2?";
    } else {
      url = "/winnre/no-auth/deals/filter-v2?isVisibleToAll=true&clientId=".concat(config === null || config === void 0 ? void 0 : config.id, "&");
    }
    var method = "get";
    url = url + "".concat(selectedTags.length > 0 ? "&tagList=".concat(tagList.join()) : "", "&pageNumber=").concat(currentPage - 1, "&endDate=").concat(date, "&status=PUBLISHED&pageSize=").concat(loadMoreOffers, "&isAscending=false&sortBy=priority&categoryList=").concat(categoryList.join()).concat(searchInput.length > 0 ? "&searchValue=".concat(searchInput) : "").concat(selectedBrands.length > 0 ? "&vendorIds=".concat(vendorList.join()) : "").concat(isRewards === true ? "&rewardsPage=true" : "").concat(isRewards === true && (cartData === null || cartData === void 0 ? void 0 : cartData.totalPoints) > 0 ? "&cartValue=".concat(cartData.totalPoints) : "");
    fetchOffers({
      isEncryptedResponse: true,
      url: url,
      method: method,
      isFormData: true
    }, function (data) {
      console.log("Offers based on query", data);
      if (isAuthenticated) {
        if ((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" || (data === null || data === void 0 ? void 0 : data.status) === "FAILED") {
          setUnauthorizedUserMessage((data === null || data === void 0 ? void 0 : data.status) === "UNAUTHORIZED" ? "Become our customer to avail deals." : "Something went wrong. Could not load offers. Please try again!");
          toast.error("Failed to load offers. Please try again later!");
          setOffers([]);
          setTotalPages(0);
          return;
        }
        if ((data === null || data === void 0 ? void 0 : data.status) === "TOKEN_EXPIRED" || (data === null || data === void 0 ? void 0 : data.status) === "INVALID_TOKEN") {
          if (isInternalWebview) {
            var _redux$authActions;
            if (dispatch && redux !== null && redux !== void 0 && (_redux$authActions = redux.authActions) !== null && _redux$authActions !== void 0 && _redux$authActions.setUnauthorizedUser) {
              dispatch(redux.authActions.setUnauthorizedUser(data.message));
            }
            return;
          }
          logout();
          return;
        }
      }
      if ((data === null || data === void 0 ? void 0 : data.content.length) === 0) {
        getOffersOfTheMonth();
      }
      setTotalPages(data.totalPages || 1);
      setOffers(data.content || []);
    });
  };

  // const getBrands = () => {
  //     cmsClient({
  //         method: 'GET',
  //         url: `/cms_service/vendors/getAllByFilter?clientId=${config?.id}${
  //             selectedCategories.length > 0
  //                 ? `&categoryIds=${categoryList.join()}`
  //                 : ''
  //         }`
  //     }).then((res) => {
  //         console.log('vendor data', res);
  //         setBrands(res.data.content);
  //     });
  // };
  var getBrands = function getBrands() {
    var url;
    if (isAuthenticated) {
      url = "/winnre/user/vendors/getAllByFilter".concat(selectedCategories.length > 0 ? "?categoryIds=".concat(categoryList.join()) : "");
    } else {
      url = "/winnre/no-auth/vendors/getAllByFilter".concat(selectedCategories.length > 0 ? "?categoryIds=".concat(categoryList.join()) : "");
    }
    var method = "get";
    fetchBrands({
      isEncryptedResponse: true,
      url: url,
      method: method,
      isFormData: true
    }, function (data) {
      console.log("AllBrands", data);
      setBrands((data === null || data === void 0 ? void 0 : data.content) || []);
    });
  };

  // const getCategories = () => {
  //     cmsClient({
  //         method: 'GET',
  //         url: 'cms_service/categories/getAll'
  //     }).then((res) => {
  //         console.log('categoriesData from deal Listing', res);
  //         setCategories(res.data.content);
  //     });
  // };

  var getCategories = function getCategories() {
    var url;
    if (isAuthenticated) {
      url = "/winnre/user/categories/getAllByFilter";
    } else {
      url = "/winnre/no-auth/categories/getAllByFilter";
    }
    var method = "get";
    fetchCategories({
      isEncryptedResponse: true,
      url: url,
      method: method,
      isFormData: true
    }, function (data) {
      console.log("categoriesData from deal Listing", data);
      setCategories((data === null || data === void 0 ? void 0 : data.content) || []);
    });
  };

  // const getTags = () => {
  //     cmsClient({
  //         method: 'GET',
  //         url: `/cms_service/tags/getAllByType?types=DEAL&pageSize=100${
  //             selectedCategories.length > 0
  //                 ? `&categoryIds=${categoryList.join()}`
  //                 : ''
  //         }`
  //     }).then((res) => {
  //         console.log('AllTags', res);
  //         const filteredTags = res?.data?.content?.filter(
  //             (tag) => tag.name !== 'Offline'
  //         );
  //         setTags(filteredTags);
  //         // setTags(res?.data?.content);
  //     });
  // };

  var getTags = function getTags() {
    var url;
    if (isAuthenticated) {
      url = "/winnre/user/tags/getAllByType?types=DEAL&pageSize=100".concat(selectedCategories.length > 0 ? "&categoryIds=".concat(categoryList.join()) : "");
    } else {
      url = "/winnre/no-auth/tags/getAllByType?types=DEAL&pageSize=100".concat(selectedCategories.length > 0 ? "&categoryIds=".concat(categoryList.join()) : "");
    }
    var method = "get";
    fetchTags({
      isEncryptedResponse: true,
      url: url,
      method: method,
      isFormData: true
    }, function (data) {
      var _data$content;
      console.log("AllTags", data);
      var filteredTags = data === null || data === void 0 || (_data$content = data.content) === null || _data$content === void 0 ? void 0 : _data$content.filter(function (tag) {
        return tag.name !== "Offline";
      });
      setTags(filteredTags);
      // setTags(data?.content);
    });
  };
  useEffect(function () {
    getOffers();
  }, [currentPage, isAuthenticated, selectedCategories, selectedTags, loadMoreOffers, selectedBrands, isRewardRefreshing]);
  useEffect(function () {
    if (brandID) {
      if (offers.length === 1) {
        var routePath = isRewards === true ? isPoints ? "/rewardpointstore/".concat(offers[0].id) : "/rewardStore/".concat(offers[0].id) : "/deals/".concat(offers[0].id);
        if (history !== null && history !== void 0 && history.replace) {
          history.replace(routePath);
        } else {
          window.location.replace(routePath);
        }
      }
    }
  }, [brandID, offers]);
  useEffect(function () {
    getTags();
    getBrands();
  }, [selectedCategories, isAuthenticated]);
  useEffect(function () {
    getCategories();
  }, [isAuthenticated]);
  return {
    offers: offers,
    loadingOffers: loadingOffers,
    offersHasError: offersHasError,
    selectedCategories: selectedCategories,
    currentPage: currentPage,
    setCurrentPage: setCurrentPage,
    totalPages: totalPages,
    unauthorizedUserMessage: unauthorizedUserMessage,
    handleChange: handleChange,
    searchInput: searchInput,
    setSelectedTags: setSelectedTags,
    setSelectedBrands: setSelectedBrands,
    setSelectedCategories: setSelectedCategories,
    selectedTags: selectedTags,
    selectedBrands: selectedBrands,
    clearFilters: clearFilters,
    categories: categories,
    brands: brands,
    tags: tags,
    setLoadMoreOffers: setLoadMoreOffers,
    loadMoreOffers: loadMoreOffers,
    topOffers: topOffers
  };
};
export default useData;